import Modal from "components/DesignSystem/Modal/Modal";
import { FileType } from "components/FileInput/FileInput";
import { UploadFromSelectorModal } from "components/UploadFromSelectorModal/UploadFromSelectorModal";
import { useToast } from "hooks/useToast";
import { useUploadFileMutation } from "store/apis/documents";
import { BackendError } from "types/utils/error";
import { ModalProps } from "types/utils/modal";
import { ReviewDftFields } from "./ReviewDftFields";
import { useState } from "react";

export const CreateDftDraft = ({
  isOpen,
  close,
  groupId,
  unsortedFolderId,
}: ModalProps & { groupId: string; unsortedFolderId: string }) => {
  const [uploadFiles, { data, isLoading, isSuccess }] = useUploadFileMutation();
  const [inkleDocFileId, setInkleDocFileId] = useState<string | null>(null);
  const { alertToast } = useToast();

  const uploadFile = async (newFile: FileType[]) => {
    const selectedFile = newFile[0];

    if (!(selectedFile instanceof File)) {
      setInkleDocFileId(selectedFile.uuid);
      return;
    }

    try {
      await uploadFiles({
        files: [selectedFile],
        groupId,
        parentFolderId: unsortedFolderId,
      }).unwrap();
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  if (inkleDocFileId) {
    return (
      <ReviewDftFields
        close={close}
        isOpen={isOpen}
        isLoading={false}
        isSuccess
        fileId={inkleDocFileId}
        groupId={groupId}
      />
    );
  }

  if (isLoading || isSuccess) {
    return (
      <ReviewDftFields
        close={close}
        isOpen={isOpen}
        isLoading={isLoading}
        isSuccess={isSuccess}
        fileId={data?.[0]?.uuid}
        groupId={data?.[0]?.group_id}
      />
    );
  }

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <Modal.Header>
          <Modal.Title>Upload Draft</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <UploadFromSelectorModal
            onDrop={uploadFile}
            groupId={groupId}
            close={() => {}}
            isOpen
            accept={{
              "application/pdf": [".pdf"],
            }}
            withModal={false}
            block
            allowSingleUpload
            hideTitle
          />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
